var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm.hibah ? _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('label', {
    attrs: {
      "for": "Jenis Harta"
    }
  }, [_vm._v(_vm._s(_vm.$t("property-type2")))]), _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.moveableProperty.property_type))])]) : _vm._e()]), _vm.moveableProperty.property_type == 'Bank' ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bank_type"
    }
  }, [_vm._v(_vm._s(_vm.$t("bank-type")))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.moveableProperty.bank_type,
      expression: "moveableProperty.bank_type"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "bank_type",
      "placeholder": "Contoh: CIMB, MBB, BIMB"
    },
    domProps: {
      "value": _vm.moveableProperty.bank_type
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moveableProperty, "bank_type", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bank_branch"
    }
  }, [_vm._v(_vm._s(_vm.$t("bank-branches")))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.moveableProperty.bank_branch,
      expression: "moveableProperty.bank_branch"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "bank_branch"
    },
    domProps: {
      "value": _vm.moveableProperty.bank_branch
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moveableProperty, "bank_branch", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bank_account_no"
    }
  }, [_vm._v(_vm._s(_vm.$t("accmembership-no")))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.moveableProperty.bank_account_no,
      expression: "moveableProperty.bank_account_no"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "bank_account_no"
    },
    domProps: {
      "value": _vm.moveableProperty.bank_account_no
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moveableProperty, "bank_account_no", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "property_value"
    }
  }, [_vm._v(_vm._s(_vm.$t("property-value")))]), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.moveableProperty.property_value,
      expression: "moveableProperty.property_value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "property_value"
    },
    domProps: {
      "value": _vm.moveableProperty.property_value
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moveableProperty, "property_value", $event.target.value);
      }
    }
  })])])])]) : _vm._e(), _vm.moveableProperty.property_type == 'Kenderaan' ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("vehicle-type")) + " "), _c('img', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy"
    }],
    staticClass: "mb-1",
    attrs: {
      "content": "Contoh : motosikal, kereta, van, lori, basikal dan lain-lain",
      "height": "15",
      "src": "/images/icon/info-button.png"
    }
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.moveableProperty.transport_type,
      expression: "moveableProperty.transport_type"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.moveableProperty.transport_type
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moveableProperty, "transport_type", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-md-6 form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("made-in")) + " "), _c('img', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy"
    }],
    staticClass: "mb-1",
    attrs: {
      "content": "Contoh : Proton, Produa, Honda, Toyota, Yamaha dan lain-lain",
      "height": "15",
      "src": "/images/icon/info-button.png"
    }
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.moveableProperty.transport_manufacturer,
      expression: "moveableProperty.transport_manufacturer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.moveableProperty.transport_manufacturer
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moveableProperty, "transport_manufacturer", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-md-6 form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("made-in")) + " "), _c('img', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy"
    }],
    staticClass: "mb-1",
    attrs: {
      "content": "Contoh : Viva 850, CR-V 2.0L I-VTEC (A), KRISS AN110F dan lain-lain",
      "height": "15",
      "src": "/images/icon/info-button.png"
    }
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.moveableProperty.transport_model,
      expression: "moveableProperty.transport_model"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.moveableProperty.transport_model
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moveableProperty, "transport_model", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-md-6 form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("org.reg-no")) + " "), _c('img', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy"
    }],
    staticClass: "mb-1",
    attrs: {
      "content": "Contoh : BNF 2705",
      "height": "15",
      "src": "/images/icon/info-button.png"
    }
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.moveableProperty.transport_registration_number,
      expression: "moveableProperty.transport_registration_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.moveableProperty.transport_registration_number
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moveableProperty, "transport_registration_number", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-md-6 form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("property-value")) + " ")]), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.moveableProperty.property_value,
      expression: "moveableProperty.property_value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "property_value"
    },
    domProps: {
      "value": _vm.moveableProperty.property_value
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moveableProperty, "property_value", $event.target.value);
      }
    }
  })])])]) : _vm._e(), _vm.moveableProperty.property_type == 'Saham' ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [['1', '2'].includes(_vm.hibah.hibah_type_id) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t("stock-name")) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.preference.hibah_fixed_saham_type,
      expression: "preference.hibah_fixed_saham_type"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "hibah_fixed_saham_type"
    },
    domProps: {
      "value": _vm.preference.hibah_fixed_saham_type
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preference, "hibah_fixed_saham_type", $event.target.value);
      }
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t("org-name")))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.moveableProperty.institution_name,
      expression: "moveableProperty.institution_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "Nama Organisasi*"
    },
    domProps: {
      "value": _vm.moveableProperty.institution_name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moveableProperty, "institution_name", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm.hibah && ['1', '2'].includes(_vm.hibah.hibah_type_id) && _vm.preferenceLabel ? _c('label', [_vm._v(" " + _vm._s(_vm.preferenceLabel) + " ")]) : _vm._e(), !['1', '2'].includes(_vm.hibah.hibah_type_id) ? _c('label', [_vm._v(" " + _vm._s(_vm.$t("accmembership-no")) + " ")]) : _vm._e(), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.moveableProperty.account_number,
      expression: "moveableProperty.account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "No Akaun / No Ahli*"
    },
    domProps: {
      "value": _vm.moveableProperty.account_number
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moveableProperty, "account_number", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("property-value")))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.moveableProperty.property_value,
      expression: "moveableProperty.property_value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "Nilai Harta*"
    },
    domProps: {
      "value": _vm.moveableProperty.property_value
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moveableProperty, "property_value", $event.target.value);
      }
    }
  })])])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('div', [[0, 1, 2].includes(_vm.hibah.status) || _vm.amendmentId ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateDetails
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]) : _vm._e()])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text",
    attrs: {
      "id": "basic-addon1"
    }
  }, [_vm._v("RM")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text",
    attrs: {
      "id": "basic-addon1"
    }
  }, [_vm._v("RM")])]);
}]

export { render, staticRenderFns }